import { Component, Input } from '@angular/core';


@Component({
  selector: 'app-coming-soon',
  imports: [],
  templateUrl: './coming-soon.component.html',
  styleUrl: './coming-soon.component.scss'
})
export class ComingSoonComponent {
  @Input() title: string = 'Coming Soon';
  @Input() message: string = 'This feature is currently under development and will be available soon.';
}
